<!--
To create a router to use as target for MSAL iframe/popup redirects. 
The actual handler logic is done inside router guard.
-->
<template>
  <div />
</template>

<script setup lang="ts">
definePage({
  name: 'AuthRedirect',
  meta: {
    doesNotRequireAuth: true
  }
})
</script>
